export function RelationLinksListForm(pObject, data) {
    var self = this;
    self.listData = ko.observable();
    self.dataList = ko.observableArray([]);

    self.saveAction = ko.observable();

    self.onAddNew = function() {
        var newRelationLink = new RelationLink(self, {
            id: null,
            linkText: '',
            relationType1: '',
            relationType2: '',
        });
        newRelationLink.editInfo(true);
        self.dataList.push(newRelationLink);
    };

    self.check = function(currentValue, index, array) {
        return currentValue.check();
    };

    self.onSave = function() {
        if (self.dataList().every(self.check)) {
            d = JSON.stringify(
                self.dataList().map(function(c) {
                    return c.dump();
                })
            );
            self.listData(d);
            self.saveAction('save');
            $('#list-form').submit();
        }
    };

    self.onLoad = function() {
        self.dataList([]);
        if (data['objList']) {
            self.dataList(
                data['objList'].map(function(c) {
                    return new pObject(self, c);
                })
            );
        }
    };

    self.onLoad();
}

export function RelationLink(parent, data) {
    var self = this;
    self.id = ko.observable(data['id']);
    self.linkText = ko.observable(data['linkText']);
    self.relationType1 = ko.observable(data['relationType1']);
    self.relationType2 = ko.observable(data['relationType2']);
    self.createdBy = ko.observable(data['createdBy']);
    self.deleted = ko.observable(false);
    self.editInfo = ko.observable(false);
    self.parent = parent;

    self.onDelete = function() {
        self.deleted(!self.deleted());
    };

    self.check = function(backToEdit) {
        return true;
    };

    self.checkNew = function(data, event) {
        if (self.linkText()) {
            $.get('/cabinet/reference/relation_link_check/', {linkText: self.linkText()}, function(
                data
            ) {
                if (data.error)
                    var dialog = $('<p>' + data.error + ' </p>.').dialog({
                        closeText: null,
                        dialogClass: 'no-close',
                        width: 400,
                        buttons: [
                            {
                                text: 'OK',
                                click: function() {
                                    $(this).dialog('close');
                                    return false;
                                },
                            },
                        ],
                    });
            }).fail(function() {});
        }

        return true;
    };

    self.dump = function() {
        return {
            id: self.id(),
            linkText: self.linkText(),
            deleted: self.deleted(),
        };
    };
}
